import React from 'react';
import { Modal } from 'react-bootstrap';
import './basicModalMobileFull.scss';
import IconClose from 'assets/icons/icon-close.svg';
const BasicModalMobileFull = ({ showModal, closeModal, info, children, bsSize = 'lg' }) => {
    return (
        <Modal bsSize={bsSize} show={showModal} dialogClassName={'full__modal__container'}>
            <div className="full__modal-heading">
                <div className="full__modal-heading__close-icon">
                    <img src={IconClose} onClick={closeModal} />
                </div>
                <h4>{info}</h4>
            </div>
            <div className="full__modal-content">{children}</div>
        </Modal>
    );
};

export default BasicModalMobileFull;
